import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "admin-mid-container" }
const _hoisted_3 = {
  class: "admin-custom-row admin-page-row",
  id: "leftMenuSlideBox"
}
const _hoisted_4 = { class: "admin-right-sidebar" }
const _hoisted_5 = { class: "admin-right-sidebar-in" }
const _hoisted_6 = { class: "admin-right-sidebar-in-top" }
const _hoisted_7 = { class: "admin-custom-row" }
const _hoisted_8 = { class: "white-bg-border" }
const _hoisted_9 = { class: "manage-profile-section" }
const _hoisted_10 = { class: "manage-profile-box" }
const _hoisted_11 = { class: "profile-edit-btn" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M15.7594 4.73184L12.268 1.24122C12.1519 1.12511 12.0141 1.03301 11.8624 0.970178C11.7107 0.907342 11.5482 0.875 11.384 0.875C11.2198 0.875 11.0572 0.907342 10.9056 0.970178C10.7539 1.03301 10.6161 1.12511 10.5 1.24122L0.866413 10.8748C0.749834 10.9905 0.657407 11.1281 0.594506 11.2798C0.531604 11.4315 0.499482 11.5942 0.500006 11.7584V15.2498C0.500006 15.5813 0.631702 15.8993 0.866123 16.1337C1.10054 16.3681 1.41849 16.4998 1.75001 16.4998H14.875C15.0408 16.4998 15.1997 16.434 15.3169 16.3168C15.4342 16.1995 15.5 16.0406 15.5 15.8748C15.5 15.7091 15.4342 15.5501 15.3169 15.4329C15.1997 15.3157 15.0408 15.2498 14.875 15.2498H7.00938L15.7594 6.49981C15.8755 6.38373 15.9676 6.24592 16.0304 6.09425C16.0933 5.94257 16.1256 5.78 16.1256 5.61583C16.1256 5.45165 16.0933 5.28908 16.0304 5.13741C15.9676 4.98573 15.8755 4.84792 15.7594 4.73184ZM8.62501 4.8834L9.92891 6.18731L3.31251 12.8037L2.0086 11.4998L8.62501 4.8834ZM1.75001 15.2498V13.0084L3.99141 15.2498H1.75001ZM5.50001 14.9912L4.19688 13.6873L7.50469 10.3791L10.8125 7.0709L12.1164 8.37481L5.50001 14.9912ZM13 7.49122L9.50938 3.99981L11.3844 2.12481L14.875 5.61622L13 7.49122Z",
      fill: "#0095FF"
    })
  ])
], -1)
const _hoisted_13 = { class: "edit-profile-form" }
const _hoisted_14 = { class: "admin-custom-row box-row-2" }
const _hoisted_15 = { class: "admin-input-field" }
const _hoisted_16 = { class: "strong-block" }
const _hoisted_17 = { class: "admin-input-field" }
const _hoisted_18 = { class: "strong-block" }
const _hoisted_19 = { class: "admin-input-field" }
const _hoisted_20 = { class: "strong-block" }
const _hoisted_21 = { class: "admin-input-field" }
const _hoisted_22 = { class: "admin-upload-profile" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "admin-site-footer" }
const _hoisted_25 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adminHeader = _resolveComponent("adminHeader")!
  const _component_adminNavigation = _resolveComponent("adminNavigation")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_adminHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_adminNavigation),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.constants['MANAGE_PROFILE_TEXT']), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.constants['PROFILE_TEXT']), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_router_link, {
                      to: "/authority/edit-profile",
                      id: "editProfileLink",
                      class: "admin-btn-outline-primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createTextVNode(" " + _toDisplayString(_ctx.constants['EDIT_PROFILE_MENU']), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.constants.FIRST_NAME_LABEL), 1),
                        _createElementVNode("strong", _hoisted_16, _toDisplayString(_ctx.firstname), 1)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.constants['LAST_NAME_LABEL']), 1),
                        _createElementVNode("strong", _hoisted_18, _toDisplayString(_ctx.lastname), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.constants['EMAIL_LABEL']), 1),
                      _createElementVNode("strong", _hoisted_20, _toDisplayString(_ctx.email), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.constants['PROFILE_PICTURE_LABEL']), 1),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("img", {
                          src: _ctx.imageUrl,
                          alt: "Avatar"
                        }, null, 8, _hoisted_23)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.constants['COPYRIGHT_TEXT']), 1)
    ])
  ]))
}